
import Vue from "vue";
import type { AdminStripeAccountSummary } from "@/api";

export default Vue.extend({
  name: "StripeAccountStatusPanel",
  props: {
    status: {
      type: Object as () => AdminStripeAccountSummary | null,
      default: null
    },
    loading: { type: Boolean, default: false },
    error: { type: String, default: "" },
    requestLoading: { type: Boolean, default: false },
    requestLink: { type: String, default: "" }
  },
  data() {
    return { copied: false };
  },
  computed: {
    statusColor(): string {
      const colors: Record<string, string> = {
        active: "success",
        restricted: "warning",
        pending: "amber lighten-2",
        disabled: "error",
        not_connected: "grey"
      };
      return colors[this.status?.status || "not_connected"];
    }
  },
  watch: {
    requestLink() {
      this.copied = false;
    }
  },
  methods: {
    async copyLink() {
      try {
        await navigator.clipboard.writeText(this.requestLink);
        this.copied = true;
        this.$emit("copied");
      } catch (error) {
        this.$emit("copy-error", error);
      }
    },
    openLink() {
      window.open(this.requestLink, "_blank", "noopener,noreferrer");
    }
  }
});
